/**
 * Display grouping + scan-code derivation for the shop-floor kiosk's
 * job-bag lookup screen. Kept as pure headless logic so it's usable from
 * the page and testable without a DOM.
 */

import type { KioskJobOperationStatus } from "../data/api-types";

export type KioskJobMilestoneGroup = "done" | "current" | "upcoming";

const GROUP_BY_STATUS: Record<KioskJobOperationStatus, KioskJobMilestoneGroup> =
  {
    finished: "done",
    external: "done",
    purged: "done",
    started: "current",
    stopped: "current",
    unplanned: "upcoming",
    lifted: "upcoming",
    planned: "upcoming",
    // Tharstern's own defensive catch-all for a status it couldn't decode —
    // treated as not-yet-done rather than assumed finished.
    unknown: "upcoming",
  };

export function milestoneGroup(
  status: KioskJobOperationStatus,
): KioskJobMilestoneGroup {
  return GROUP_BY_STATUS[status];
}
